import { Component, OnInit } from '@angular/core';
import * as Rellax from 'rellax';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { LandingPageService } from './landing-page.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  providers: [LandingPageService]
})
export class LandingPageComponent implements OnInit {
  data : Date = new Date();
  idExtraAsset: Number = 1;
  focus;
  focus1;
  tipoMeteo=1;

  rifBollettinoOggi:any;
  rifBollettinoDomani:any;

  data2: { [key: string]: string } = {
    '1': 'peppe',
    '2': 'mario',
    '3': 'luigi',
  };

  colors: { [key: string]: string } = {
    peppe: 'red',
    mario: 'blue',
    luigi: 'green',
  };
  

  newsList= []
  ultimoAllertamentoOggi: any = [{
    livello: 0
  }];
  lungOggi: number;
  ultimoAllertamentoDomani: any = [{
    livello: 0
  }];
  lungDomani: number;
  checkOggi: any;
  checkDomani: any;
  descrizioneSezione: any;
  

  constructor(
    private restService: LandingPageService,
    private _sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('landing-page');
    var navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.add('navbar-transparent');
    this.loadNews();
    this.coloraPaths()
    this.getLivelliAllarme()
    this.findDescrizioneChiSiamo();
  }

  loadNews(){
    this.newsList = [
      { giorno: "06", mese: "Dic", titolo: "Forti piogge colpiscono la costa", testo: "Le forti piogge hanno causato allagamenti in diverse zone costiere. Le autorità invitano alla massima prudenza durante gli spostamenti." },
      { giorno: "05", mese: "Dic", titolo: "Neve record in montagna", testo: "Le montagne del nord hanno registrato nevicate record durante la notte. Gli impianti sciistici sono in piena attività!" },
      { giorno: "04", mese: "Dic", titolo: "Tempesta di vento spazza la città", testo: "Raffiche di vento fino a 100 km/h hanno colpito la città. Diversi alberi caduti e disagi alla viabilità." },
      { giorno: "03", mese: "Dic", titolo: "Giornata di sole dopo la tempesta", testo: "Dopo giorni di maltempo, oggi è prevista una giornata di sole in tutta la regione. Ideale per una passeggiata all'aperto." },
    ];
  };

  findDescrizioneChiSiamo() {
    this.restService.findExtraById(this.idExtraAsset).then(
      res => {
        if (res) {
          this.descrizioneSezione = this._sanitizer.bypassSecurityTrustHtml(res.descrizione);
        }
      }

    )
  }
  private formatDataOra(dataOra: string): string {
  // Esempio: "13:37 - 29/07/2025"
  const [ora, data] = dataOra.split(' - ');
  if (!ora || !data) return dataOra;
  return `${ora} del ${data}`;
}

  formatLivelloDesc(livelloDesc: string): any {
    if (!livelloDesc) return '';
    
    // Dividi la stringa per formattarla su 3 righe
    // Pattern: "Livello di allerta idrogeologica e/o idraulica verde"
    // Diventa: "Livello di allerta <br/> idrogeologica e/o idraulica <br/> verde"
    
    // Cerca "Livello di allerta" come punto di divisione
    const allertaIndex = livelloDesc.toLowerCase().indexOf('livello di allerta');
    if (allertaIndex === -1) return livelloDesc;
    
    // Estrai la parte dopo "Livello di allerta"
    const afterAllerta = livelloDesc.substring(allertaIndex + 'Livello di allerta'.length).trim();
    
    // Trova l'ultima parola (che dovrebbe essere il colore/stato: verde, arancione, rosso, ecc.)
    const words = afterAllerta.split(' ');
    if (words.length === 0) return livelloDesc;
    
    // L'ultima parola è il colore/stato
    const lastWord = words[words.length - 1];
    // Tutto il resto è la parte centrale
    const middlePart = words.slice(0, -1).join(' ');
    
    // Gestisci la conversione di genere per i colori
    let formattedLastWord: string;
    const lastWordLower = lastWord.toLowerCase();
    if (lastWordLower === 'giallo') {
      formattedLastWord = 'GIALLA';
    } else if (lastWordLower === 'rosso') {
      formattedLastWord = 'ROSSA';
    } else {
      formattedLastWord = lastWord.toUpperCase();
    }
    
    // Costruisci la stringa formattata
    let formatted = 'Livello di allerta';
    if (middlePart) {
      formatted += '<br/>' + middlePart;
    }
    formatted += '<br/>' + formattedLastWord;
    
    // Sanitizza l'HTML per sicurezza
    return this._sanitizer.bypassSecurityTrustHtml(formatted);
  }
  randomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  selezionaMeteo(tipo){
    this.tipoMeteo = tipo;
  }

  coloraPaths(): void {
    const svg = document.getElementById('svg_zone_xml');
    if (svg) {
      // Seleziona tutti i path all'interno dell'SVG
      const paths = svg.querySelectorAll('path');
      
      paths.forEach((path) => {
        const id = path.getAttribute('id');
        if (id && this.data[id]) {
          const value = this.data2[id];
          const color = this.colors[value] || '#bababa'; // Default color
          
          // Cast path to SVGPathElement
          (path as SVGPathElement).style.fill = color;
        }
      });
    }
  }
  
  ngOnDestroy(){
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('landing-page');
    var navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.remove('navbar-transparent');
  };

  getLivelliAllarme() {
    this.restService.selectAllOggi().then(
      res => {
        if(res){
          this.rifBollettinoOggi = {
          dataDa: this.formatDataOra(res.dataDa),
          dataA: this.formatDataOra(res.dataA),
        };
          this.checkOggi = res.checkAvviso
          if (res.bollettinoMeteoBindList.length > 0) {

            this.ultimoAllertamentoOggi = res.bollettinoMeteoBindList[0];
            this.lungOggi = 1;

          } else {

            this.ultimoAllertamentoOggi = res.bollettinoMeteoBindList;
            this.lungOggi = 0;

          }
        }
      }
    ).catch(error => {
      this.ultimoAllertamentoOggi = [{
        livello: 0
      }];
      this.lungOggi = 0;
    });

    this.restService.selectAllDomani().then(
      res => {
        if(res){
          this.checkDomani = res.checkAvviso
          this.rifBollettinoDomani = {
          dataDa: this.formatDataOra(res.dataDa),
          dataA: this.formatDataOra(res.dataA),
        };
          if (res.bollettinoMeteoBindList.length > 0) {

            if(res.bollettinoMeteoBindList && res.bollettinoMeteoBindList[0]){
              this.ultimoAllertamentoDomani = res.bollettinoMeteoBindList[0];
            }

            this.lungDomani = 1;

            
          } else {
            
            if(res.bollettinoMeteoBindList && res.bollettinoMeteoBindList[0]){
              this.ultimoAllertamentoDomani = res.bollettinoMeteoBindList;
            }
            this.lungDomani = 0;
            
          }
        }
      }
    ).catch(error => {
      this.ultimoAllertamentoDomani= [{
        livello: 0
      }];
      this.lungDomani = 0;
    });
  }

  
}
